import { useStore } from "./store";

export function useBase() {
	return {
		...useStore()
	};
}

const useBaseStore = useBase;
export { useBaseStore };

export * from "./common";
export * from "./types/index.d";
